import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
	container: {
		marginTop: 10,
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		paddingLeft: 30,
		gap: 4,
	},
	title: {
		fontSize: "clamp(30px, 2.5vw, 36px)",
		color: "#fff",
		textAlign: "left",
		lineHeight: 1.2,
        letterSpacing: "-0.36px",
		width: "65%",
	},
	subtitle: {
		fontSize: "clamp(16px, 1.5vw, 20px)",
		color: "#fff",
		textAlign: "left",
		fontWeight: "normal",
		width: "100%",
	},
}));

export default useStyles;

